import React from 'react';
import { Row, Col } from 'reactstrap';

import everest from '../../static-db/everest';
import jomsom from '../../static-db/jomsom';
import ramechhap from '../../static-db/ramechhap';

const prices = {
  everest: everest.pricesToCompare,
  jomsom: jomsom.pricesToCompare,
  ramechhap: ramechhap.pricesToCompare,
};

export default function ComparePricesSection({ flight }) {
  if (!flight) return null;
  const { arrival, departure } = flight[0];

  let key = '';
  if ((arrival === 'KTM' && departure === 'LUA') || (arrival === 'LUA' && departure === 'KTM')) {
    key = 'everest';
  } else if ((arrival === 'JMO' && departure === 'PKR') || (arrival === 'PKR' && departure === 'JMO')) {
    key = 'jomsom';
  } else if ((arrival === 'LUA' && departure === 'RHP') || (arrival === 'RHP' && departure === 'LUA')) {
    key = 'ramechhap';
  }
  
  const pricesToCompare = prices[key];
  if (!pricesToCompare) return null;
  
  return (
    <Row>
      <Col lg="12">
        <div className="content-block">
          <span>Price compare</span>
          <ul className="prices">
            {pricesToCompare.map(({ url, price, subText }) => (
                <li className="block" style={{backgroundImage: `url(${url})`}}>
                  <h6>{price}</h6>
                  <span>{subText}</span>
                </li>
            ))}
          </ul>
        </div>
      </Col>
    </Row>
  );
}



// WEBPACK FOOTER //
// ./src/screens/Flights/SearchAndResults/StaticSections/ComparePricesSection.js